// extracted by mini-css-extract-plugin
export default {"box":"Telegram_box__oiAQ2","client":"Telegram_client__xCm9h","content":"Telegram_content__wnhQg"};